const instructors = [
  {
    name: 'Ana Costa',
    role: 'Yoga & Hatha',
    bio: 'Com 12 anos de experiência, Ana guia com gentileza e profundidade, adaptando cada prática à jornada única de cada aluno.',
    img: 'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=500&q=80',
    cert: 'RYT-500 · Iyengar Certified',
  },
  {
    name: 'Rui Santos',
    role: 'Meditação & Mindfulness',
    bio: 'Praticante há 15 anos, Rui transmite a arte da presença com clareza e calma, tornando a meditação acessível a todos.',
    img: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=500&q=80',
    cert: 'MBSR · Vipassana Teacher',
  },
  {
    name: 'Maria Luz',
    role: 'Vinyasa & Yin Yoga',
    bio: 'Formada em Bali, Maria traz fluidez e intenção a cada aula, criando sequências que respeitam o ritmo natural do corpo.',
    img: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=500&q=80',
    cert: 'RYT-200 · Yin Yoga Certified',
  },
  {
    name: 'Sofia Melo',
    role: 'Massagem Terapêutica',
    bio: 'Especializada em técnicas orientais e ocidentais, Sofia restaura o equilíbrio energético com intuição e maestria.',
    img: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=500&q=80',
    cert: 'Shiatsu · Deep Tissue Certified',
  },
  {
    name: 'Pedro Alves',
    role: 'Nutrição Holística',
    bio: 'Pedro combina ciência nutricional com sabedoria ancestral para criar planos alimentares que nutrem corpo e alma.',
    img: 'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=500&q=80',
    cert: 'CNP · Ayurveda Nutrition',
  },
  {
    name: 'Catarina Reis',
    role: 'Yoga & Meditação',
    bio: 'Catarina integra movimento e silêncio nas suas práticas, criando um espaço seguro para a exploração interior.',
    img: 'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=500&q=80',
    cert: 'RYT-300 · Yoga Nidra Teacher',
  },
];

export default function Instructors() {
  return (
    <section id="instrutores" className="py-28 bg-cream">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-20 reveal">
          <p className="font-dm text-xs tracking-[0.4em] text-sage uppercase mb-4">A nossa equipa</p>
          <h2 className="font-playfair italic text-5xl font-light text-ink">Instrutores</h2>
          <div className="w-12 h-px bg-sage mx-auto mt-6" />
          <p className="font-dm text-base text-ink-light mt-6 max-w-md mx-auto leading-relaxed">
            Especialistas apaixonados, dedicados à tua transformação pessoal.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-6">
          {instructors.map((ins, i) => (
            <div
              key={ins.name}
              className="instructor-card reveal group cursor-pointer"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="relative overflow-hidden rounded-2xl aspect-[3/4]">
                <img
                  src={ins.img}
                  alt={ins.name}
                  className="instructor-img w-full h-full object-cover"
                />
                {/* Hover overlay */}
                <div className="instructor-overlay absolute inset-0 bg-gradient-to-t from-ink/80 via-ink/20 to-transparent flex flex-col justify-end p-6">
                  <p className="font-dm text-[10px] tracking-[0.25em] text-sage-light uppercase mb-1">{ins.cert}</p>
                  <p className="font-dm text-sm text-white/80 leading-relaxed">{ins.bio}</p>
                </div>
              </div>
              <div className="pt-4 px-1">
                <h3 className="font-playfair text-lg font-medium text-ink">{ins.name}</h3>
                <p className="font-dm text-xs text-sage tracking-wide mt-0.5">{ins.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
